<!-- <mat-icon style="color:#FFDD00;">warning</mat-icon>  -->
<h2 mat-dialog-title>{{data.headerText}}</h2>
<mat-dialog-content class="mat-typography">
  <h3>{{data.bodyText}}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>